import { z } from 'zod';
import { TradeProfileEstimateStyleSchema, TradeProfileSchema } from '../trade-profiles/schema';
/** Trade profile API DTOs (`GET /trade-profiles[/:key]`). */
export const TradeProfileSummarySchema = z.object({
    key: z.string(),
    name: z.string(),
    version: z.number().int().min(1),
    isGeneric: z.boolean(),
    estimateStyle: TradeProfileEstimateStyleSchema,
});
export const TradeProfilesListResponseSchema = z.array(TradeProfileSummarySchema);
/** Full profile document, validated by the shared profile schema. */
export const TradeProfileResponseSchema = TradeProfileSchema;
//# sourceMappingURL=trade-profiles.js.map